const prod = '//lsh.local/tocs_app/meet-the-team/datafeed/';
const ref = 'https://www.lsh.co.uk/tocs_app/meet-the-team/datafeed/';
const dev  = 'https://cs-pub.konstructive.com/datafeed/';

export default {
    local: prod,
    endpoint: dev,
    reference: ref,
    password : 'ilm2020',
    passwordEmail : 'marketing@lsh.co.uk',
    defaultContacts :  [
      {
        "region": "",
        "name": "Steve Williams",
        "location": "National Head of industrial & Logistics",
        "phone": "0207 198 2296",
        "email": "sawilliams@lsh.com",
        "image": "lsh_staff__0010_steve-williams.png"
      },
      {
        "region": "",
        "name": "Alex Carr",
        "location": "Director, Capital Markets - Industrial & Logistics",
        "phone": "0207 198 2233",
        "email": "acarr@lsh.com",
        "image": "lsh_staff__0010_alex-carr.png"
      },
      {
        "region": "",
        "name": "Oliver Du Sautoy",
        "location": "Head of Research",
        "phone": "0207 198 2193",
        "email": "odusautoy@lsh.com",
        "image": "lsh_staff__0010_oliver-du-sautoy.png"
      }
    ]
}


// WEBPACK FOOTER //
// ./src/js/constants.js